import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PermissionsKey } from "../data/permissions";

export interface AdminState {
  accessToken: string;
  permissions: PermissionsKey[];
}

const initialState: AdminState = {
  accessToken: "",
  permissions: [],
};

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    loginAdmin(
      state,
      action: PayloadAction<{
        accessToken: string;
        permissions: PermissionsKey[];
      }>
    ) {
      state.accessToken = action.payload.accessToken;
      state.permissions = action.payload.permissions;
    },
    logoutAdmin(state) {
      state.accessToken = "";
      state.permissions = [];
    },
    updatePermiossions(
      state,
      action: PayloadAction<{ permissions: PermissionsKey[] }>
    ) {
      state.permissions = action.payload.permissions;
    },
  },
});

export const {
  loginAdmin,
  logoutAdmin,
  updatePermiossions,
} = adminSlice.actions;
export default adminSlice.reducer;
